import React from 'react';
import { Image, NoAvatarContainer } from 'components/user-avatar/style';
import { ucFirst } from 'utils/js';

export interface UserAvatarProps {
  user: any;
}

const defaultProps = {};

function UserAvatar({ user }: UserAvatarProps) {
  if (user?.avatar) {
    return <Image src={user.avatar} />;
  }

  if (user?.firstName) {
    return (
      <NoAvatarContainer>
        {user?.firstName && ucFirst(user?.firstName[0])}
        {user?.lastName && ucFirst(user?.lastName[0])}
      </NoAvatarContainer>
    );
  }

  return null;
}

UserAvatar.defaultProps = defaultProps;

export default UserAvatar;
